export enum ServerStatusEnum {
  POLACZONY = 'POLACZONY',
  ODLACZONY = 'ODLACZONY',
  AWARIA = 'AWARIA',
}
